import React, { useEffect } from 'react'
import Layout from '../components/Layout'
import '../stylings/contact.css'
import { useDispatch } from 'react-redux'
import { hideLoading, showLoading } from '../redux store/loader'

const contactCards = [
  { icon: 'fa-solid fa-phone',         color: '#1a3c72', label: 'Call Us',    value: '9999740333',              href: 'tel:9999740333',                           action: 'Tap to Call'   },
  { icon: 'fa-solid fa-envelope',      color: '#7c3aed', label: 'Email Us',   value: 'vjconvent2004@gmail.com', href: 'mailto:vjconvent2004@gmail.com',            action: 'Send Email', lower: true },
  { icon: 'fa-solid fa-location-dot',  color: '#16a34a', label: 'Visit Us',   value: 'Khasra No.-142, Plot-289, Delhi-110081', href: 'https://maps.google.com/?q=Vidya+Jain+Convent+School', action: 'Get Directions' },
  { icon: 'fa-brands fa-whatsapp',     color: '#25d366', label: 'WhatsApp',   value: '9999740333',              href: 'https://wa.me/919999740333',               action: 'Chat Now'      },
]

const infoItems = [
  { icon: 'fa-solid fa-location-dot', color: '#1a3c72', label: 'Address',      value: 'Khasra No.- 142, Plot - 289, Delhi - 110081' },
  { icon: 'fa-solid fa-phone',        color: '#7c3aed', label: 'Phone',        value: '9999740333' },
  { icon: 'fa-solid fa-envelope',     color: '#16a34a', label: 'Email',        value: 'vjconvent2004@gmail.com', lower: true },
  { icon: 'fa-solid fa-clock',        color: '#f5a623', label: 'School Hours', value: 'Mon – Sat: 8:00 AM – 2:30 PM' },
]

const socialLinks = [
  { icon: 'fa-brands fa-facebook-f', color: '#1877f2', href: '#',  label: 'Facebook'  },
  { icon: 'fa-brands fa-instagram',  color: '#e1306c', href: '#',  label: 'Instagram' },
  { icon: 'fa-brands fa-youtube',    color: '#ff0000', href: '#',  label: 'YouTube'   },
  { icon: 'fa-brands fa-whatsapp',   color: '#25d366', href: 'https://wa.me/919999740333', label: 'WhatsApp' },
]

const ContactUs = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(showLoading())
    setTimeout(() => { dispatch(hideLoading()) }, 1700)
  }, [])

  return (
    <Layout>
      <div className="cu-page">

        {/* ── Hero ── */}
        <div className="cu-hero">
          <div className="cu-hero-dots" />
          <div className="cu-hero-blob cu-hero-blob--1" />
          <div className="cu-hero-blob cu-hero-blob--2" />
          <div className="container cu-hero-inner">
            <div className="cu-hero-tag">
              <i className="fa-solid fa-headset"></i> Get in Touch
            </div>
            <h1 className="cu-hero-title">Contact Us</h1>
            <p className="cu-hero-sub">
              We'd love to hear from you — reach out for admissions, enquiries or general information about Vidya Jain Convent School.
            </p>
          </div>
        </div>

        {/* ── Quick Contact Cards ── */}
        <div className="cu-cards-band">
          <div className="container">
            <div className="cu-cards-grid">
              {contactCards.map((card, i) => (
                <a
                  key={i}
                  href={card.href}
                  target={card.href.startsWith('http') ? '_blank' : undefined}
                  rel="noopener noreferrer"
                  className="cu-card"
                  style={{ '--cc': card.color }}
                >
                  <div className="cu-card-icon"><i className={card.icon}></i></div>
                  <div className="cu-card-text">
                    <span className="cu-card-label">{card.label}</span>
                    <strong className={`cu-card-value${card.lower ? ' cu-lower' : ''}`}>{card.value}</strong>
                  </div>
                  <div className="cu-card-action">
                    {card.action} <i className="fa-solid fa-arrow-right"></i>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* ── Map + Info ── */}
        <div className="container cu-body">
          <div className="cu-main-grid">

            {/* Left — Info panel */}
            <div className="cu-info-panel">
              <div className="cu-panel-tag">
                <i className="fa-solid fa-circle-info"></i> School Info
              </div>
              <h2 className="cu-panel-title">Vidya Jain Convent School</h2>
              <p className="cu-panel-desc">
                Affiliated to CBSE (Affiliation No. 2730922), we are committed to nurturing young minds with quality education and a holistic learning environment.
              </p>

              <div className="cu-info-list">
                {infoItems.map((item, i) => (
                  <div className="cu-info-row" key={i}>
                    <div className="cu-info-row-icon" style={{ '--cc': item.color }}>
                      <i className={item.icon}></i>
                    </div>
                    <div className="cu-info-row-text">
                      <span className="cu-info-row-label">{item.label}</span>
                      <p className={`cu-info-row-value${item.lower ? ' cu-lower' : ''}`}>{item.value}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Socials */}
              <div className="cu-socials">
                <span className="cu-socials-label">Follow Us</span>
                <div className="cu-socials-row">
                  {socialLinks.map((s, i) => (
                    <a key={i} href={s.href} target="_blank" rel="noopener noreferrer"
                       className="cu-social-btn" style={{ '--cc': s.color }} aria-label={s.label}>
                      <i className={s.icon}></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Right — Map */}
            <div className="cu-map-panel">
              <div className="cu-map-header">
                <i className="fa-solid fa-map-location-dot"></i>
                Find Us on Map
              </div>
              <div className="cu-map-wrap">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d55976.08036316858!2d77.016338!3d28.734335!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d07d161ca9ba1%3A0x31f5fa9d1ce42c61!2sVidya%20Jain%20Convent%20School!5e0!3m2!1sen!2sin!4v1710967789836!5m2!1sen!2sin"
                  className="cu-map"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Vidya Jain Convent School Location"
                  allowFullScreen
                />
              </div>
              <a href="https://maps.google.com/?q=Vidya+Jain+Convent+School"
                 target="_blank" rel="noopener noreferrer" className="cu-directions-btn">
                <i className="fa-solid fa-diamond-turn-right"></i>
                Get Directions
              </a>
            </div>

          </div>
        </div>

      </div>
    </Layout>
  )
}

export default ContactUs
